"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4479],{

/***/ 83228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function CardLink(param) {
    var children = param.children, className = param.className, externalUrl = param.externalUrl, linkPath = param.linkPath;
    var linkClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'flex flex-1 flex-col group');
    if (externalUrl) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: externalUrl,
            target: "_blank",
            rel: "nofollow noopener noreferrer",
            className: linkClassName,
            children: children
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
        href: linkPath,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: linkClassName,
            children: children
        })
    }));
};


/***/ }),

/***/ 34455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CodeFeatureCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_renderers_Code__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52082);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CodeFeatureCard(_param) {
    var reverse = _param.reverse, id = _param.id, props = _objectWithoutProperties(_param, [
        "reverse",
        "id"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "px-6 md:py-3",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Code__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, props, {
            className: "my-6 h-full w-full",
            noCopy: true
        }))
    }, id));
};


/***/ }),

/***/ 69926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContentBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_renderers_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27910);
/* harmony import */ var _components_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89338);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68663);






function ContentBlock(param, index) {
    var image = param.image, title = param.title, content = param.content, cta = param.cta, ctaTo = param.ctaTo;
    var isEven = index % 2;
    var wrapperClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()('-mx-6 flex items-center flex-col lg:flex-row py-6 lg:py-12', {
        'lg:flex-row-reverse': isEven
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: wrapperClass,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-6 flex w-full items-center justify-center px-6 lg:mb-0 lg:w-1/2",
                children: image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative z-20 m-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        src: image.url,
                        title: title,
                        alt: title,
                        width: image.width,
                        height: image.height,
                        quality: 100,
                        objectFit: "cover",
                        className: "h-full w-full rounded"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full px-6 lg:w-1/2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "-mt-6",
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            level: 4,
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            content: content
                        }),
                        ctaTo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            href: ctaTo,
                            colour: "purple",
                            children: [
                                cta || 'Learn more',
                                " →"
                            ]
                        })
                    ]
                })
            })
        ]
    }, index));
};


/***/ }),

/***/ 49000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconContentBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4751);
/* harmony import */ var _components_renderers_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31515);
/* harmony import */ var _components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37324);
/* harmony import */ var _components_Pill__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79506);






function IconContentBlock(param, index) {
    var icon = param.icon, title = param.title, description = param.description, _comingSoon = param.comingSoon, comingSoon = _comingSoon === void 0 ? false : _comingSoon, cta = param.cta, ctaTo = param.ctaTo, ctaClass = param.ctaClass;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex w-full p-6 md:w-1/2 lg:w-1/3",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex w-full flex-col justify-between rounded-lg bg-whisper p-6",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-6 flex h-12 w-12 items-center justify-center text-cornflower",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                icon: icon
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-baseline",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    className: "font-bold text-haiti",
                                    children: title
                                }),
                                comingSoon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Pill__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    label: "Soon",
                                    size: "small",
                                    className: "ml-4"
                                })
                            ]
                        }),
                        description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: "text-mid-gray",
                            children: description
                        })
                    ]
                }),
                ctaTo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_renderers_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    href: ctaTo,
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('cursor-pointer', ctaClass),
                    children: [
                        cta || 'Learn more',
                        " →"
                    ]
                })
            ]
        })
    }, index));
};


/***/ }),

/***/ 98969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IndustryList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./src/components/renderers/Heading.tsx
var Heading = __webpack_require__(27910);
// EXTERNAL MODULE: ./src/components/MarkdownRenderer.tsx + 13 modules
var MarkdownRenderer = __webpack_require__(89338);
// EXTERNAL MODULE: ./src/components/Testimonial.js
var Testimonial = __webpack_require__(27221);
;// CONCATENATED MODULE: ./src/components/IndustryCard.js






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function IndustryCard(param, index) {
    var id = param.id, slug = param.slug, title = param.title, subTitle = param.subTitle, content = param.content, featuredContent = param.featuredContent, _isFeatured = param.isFeatured, isFeatured = _isFeatured === void 0 ? false : _isFeatured, _caseStudies = param.caseStudies, caseStudies = _caseStudies === void 0 ? [] : _caseStudies;
    var _caseStudies1 = _slicedToArray(caseStudies, 1), caseStudy = _caseStudies1[0];
    var isEven = index % 2;
    var wrapperClass = classnames_default()('-mx-6 flex items-center flex-col lg:flex-row', {
        'lg:flex-row-reverse': isEven || isFeatured
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "md:py-6",
        children: [
            !isFeatured && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto mb-6 max-w-2xl text-center md:mb-12 lg:max-w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        level: 2,
                        id: slug,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "my-6 inline-block h-1 w-24 rounded border-0 bg-cornflower md:w-48"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: wrapperClass,
                children: [
                    caseStudy && /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                        className: "mb-12 w-full max-w-2xl px-6 lg:mb-0 lg:w-1/2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* default */.Z, _objectSpread({}, caseStudy, {
                            linkPath: "/case-studies/".concat(caseStudy.slug)
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full max-w-2xl px-6 lg:w-1/2",
                        children: [
                            !isFeatured && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "-mt-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    level: 3,
                                    children: subTitle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownRenderer/* default */.Z, {
                                content: isFeatured && featuredContent ? featuredContent : content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4 lg:mt-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: "/customers/".concat(slug),
                                    appearance: "outline",
                                    colour: "pink",
                                    children: "Learn more →"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }, id));
};

;// CONCATENATED MODULE: ./src/components/IndustryList.js


function IndustryList(param) {
    var _entries = param.entries, entries = _entries === void 0 ? [] : _entries, _Component = param.Component, Component = _Component === void 0 ? IndustryCard : _Component;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: entries.map(Component)
    }));
};


/***/ }),

/***/ 31822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Showcase; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Showcase/context.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ShowcaseStateContext = /*#__PURE__*/ (0,react.createContext)({});
var ShowcaseDispatchContext = /*#__PURE__*/ (0,react.createContext)({});
function gridReducer(state, param) {
    var type = param.type, section = param.section;
    switch(type){
        case "SET_ACTIVE":
            return _objectSpread({}, state, {
                activeSection: section
            });
        default:
            throw new Error("Invalid action: ".concat(type));
    }
}
function ShowcaseProvider(param) {
    var children = param.children, defaultSection = param.defaultSection;
    var ref = (0,react.useReducer)(gridReducer, {
        activeSection: defaultSection
    }), state = ref[0], dispatch = ref[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    }));
}
function useShowcaseState() {
    var context = (0,react.useContext)(ShowcaseStateContext);
    if (!context) throw new Error("useShowcaseState must be used within a ShowcaseProvider");
    return context;
}
function useShowcaseDispatch() {
    var context = (0,react.useContext)(ShowcaseDispatchContext);
    if (!context) throw new Error("useShowcaseDispatch must be used within a ShowcaseProvider");
    return context;
}


// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/Showcase/FeatureCard.tsx


function FeatureCard(param) {
    var featuredImage = param.featuredImage;
    if (!featuredImage) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full max-w-5xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
            src: featuredImage.url,
            alt: featuredImage === null || featuredImage === void 0 ? void 0 : featuredImage.alt,
            layout: "fill"
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/Showcase/Items.tsx



function Items_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Items_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Items_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ShowcaseItems(param) {
    var Component = param.Component, items = param.items;
    var activeSection = useShowcaseState().activeSection;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: items.map(function(item, index) {
            var isActive = item === activeSection;
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()({
                    hidden: !isActive,
                    block: isActive
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, Items_objectSpread({}, item, {
                    isFeatured: true
                }))
            }, index));
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/Showcase/Nav.tsx



function ShowcaseNav(param) {
    var horizontalLayout = param.horizontalLayout, _items = param.items, items = _items === void 0 ? [] : _items;
    var dispatch = useShowcaseDispatch();
    var activeSection = useShowcaseState().activeSection;
    if (!items || items.length === 0) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()({
            'py-3 md:items-center md:justify-around lg:flex': horizontalLayout,
            'px-4 md:w-2/5': !horizontalLayout
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("mt-6 text-center", {
                'rounded bg-white px-3 shadow': horizontalLayout,
                'flex flex-col': !horizontalLayout
            }),
            children: items.map(function(item, index) {
                var isActive = item === activeSection;
                var showDescription = !horizontalLayout && isActive && item.description;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: classnames_default()("focus:outline-none my-2 inline-block cursor-pointer font-bold hover:text-rose focus:text-rose", {
                        'text-rose': isActive,
                        'py-2 px-3 text-center text-sm text-cornflower': horizontalLayout,
                        'flex flex-col rounded py-3 px-4 text-left text-base text-mid-gray': !horizontalLayout,
                        'bg-white shadow-sm': isActive && !horizontalLayout
                    }),
                    onClick: function() {
                        return dispatch({
                            type: "SET_ACTIVE",
                            section: item
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("flex items-center", {
                                'text-lg': !horizontalLayout
                            }),
                            children: item.title
                        }),
                        showDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mt-2 font-medium text-haiti",
                            children: item.description
                        })
                    ]
                }, index));
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/Showcase/index.tsx






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function Showcase(param) {
    var _Component = param.Component, Component = _Component === void 0 ? FeatureCard : _Component, items = param.items, _layout = param.layout, layout = _layout === void 0 ? "horizontal" : _layout;
    var _items = _slicedToArray(items, 1), firstItem = _items[0];
    var horizontalLayout = layout === "horizontal";
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseProvider, {
        defaultSection: firstItem,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()({
                '-mx-4 items-start md:flex': !horizontalLayout
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseNav, {
                    items: items,
                    horizontalLayout: horizontalLayout
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("px-4", {
                        'md:w-3/5': !horizontalLayout
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseItems, {
                        Component: Component,
                        items: items
                    })
                })
            ]
        })
    }));
};


/***/ }),

/***/ 27221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Testimonial; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var _components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37324);
/* harmony import */ var _components_Authors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56794);
/* harmony import */ var _components_CardLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83228);
/* harmony import */ var _svg_icons_quote_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84915);






function Testimonial(param) {
    var externalUrl = param.externalUrl, linkPath = param.linkPath, title = param.title, coverImage = param.coverImage, customer = param.customer, company = param.company;
    var hasLogo = company && company.logo;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CardLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        externalUrl: externalUrl,
        linkPath: linkPath,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "transform rounded shadow-lg transition-all duration-100 ease-in-out hover:scale-105 hover:shadow-2xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative",
                    children: [
                        coverImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "z-20",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                src: coverImage.url,
                                title: title,
                                alt: title,
                                width: 960,
                                height: 540,
                                quality: 100,
                                objectFit: "cover",
                                className: "rounded"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "absolute bottom-0 left-0 -mb-1 w-full fill-current text-cornflower",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 1440 320",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M0,192L120,208C240,224,480,256,720,234.7C960,213,1200,139,1320,101.3L1440,64L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "rounded-b bg-cornflower p-6",
                    children: customer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative z-20 rounded bg-white p-6 text-haiti shadow-lg",
                        children: [
                            customer.bio && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pin-t pin-l absolute -mt-3 -ml-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_icons_quote_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            className: "w-10 text-whisper"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative -mt-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            className: "text-sm italic",
                                            children: customer.bio
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "-ml-3 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "-ml-px flex-grow",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Authors__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            people: [
                                                customer
                                            ],
                                            showTitle: true
                                        })
                                    }),
                                    hasLogo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-16",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                            src: company.logo.url,
                                            width: company.logo.width,
                                            height: company.logo.height,
                                            title: company.name,
                                            alt: company.name
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }));
};


/***/ })

}]);